import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventToggleRecordAutomatically } from 'entities/Users/api/types'

type IHandlerEvent = (data: IResponseEventToggleRecordAutomatically) => void

export const useEventToggleRecordAutomatically = (handler?: IHandlerEvent) => {
  const { websocket, usersStore } = useEntitiesContext()

  const defaultHandler = (data: IResponseEventToggleRecordAutomatically) => {
    usersStore.isRecordAutomatically = data.isRecordAutomatically
    handler?.(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.UserToggleRecordAutomatically, defaultHandler), [])
}
